import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

const productPriceIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.375 8.125C6.375 7.76042 6.49219 7.46094 6.72656 7.22656C6.96094 6.99219 7.26042 6.875 7.625 6.875C7.98958 6.875 8.28906 6.99219 8.52344 7.22656C8.75781 7.46094 8.875 7.76042 8.875 8.125C8.875 8.48958 8.75781 8.78906 8.52344 9.02344C8.28906 9.25781 7.98958 9.375 7.625 9.375C7.26042 9.375 6.96094 9.25781 6.72656 9.02344C6.49219 8.78906 6.375 8.48958 6.375 8.125ZM10.9844 3.75C11.6615 3.75 12.2474 3.9974 12.7422 4.49219L19.6172 11.3672C20.0859 11.862 20.3203 12.4479 20.3203 13.125C20.3203 13.8021 20.0859 14.388 19.6172 14.8828L14.3828 20.1172C13.888 20.5859 13.3021 20.8203 12.625 20.8203C11.9479 20.8203 11.362 20.5859 10.8672 20.1172L3.99219 13.2422C3.4974 12.7474 3.25 12.1615 3.25 11.4844V5.625C3.27604 5.10417 3.45833 4.66146 3.79688 4.29688C4.16146 3.95833 4.60417 3.77604 5.125 3.75H10.9844ZM5.32031 11.9141L12.1953 18.7891C12.4818 19.0234 12.7682 19.0234 13.0547 18.7891L18.2891 13.5547C18.5234 13.2682 18.5234 12.9818 18.2891 12.6953L11.4141 5.82031C11.2839 5.6901 11.1406 5.625 10.9844 5.625H5.125V11.4844C5.125 11.6406 5.1901 11.7839 5.32031 11.9141Z"
            fill="#FFA10B"
        />
    </svg>
);

registerBlockType(metadata.name, {
    icon: productPriceIcon,
    title: metadata.title,
    edit: Edit,
});
